import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment';

@Pipe({
   name: 'formatDate'
})

export class FormatDate implements PipeTransform {
  transform(value: string, format: string = ''): string {
    return (value && value !== '') ? moment(value).format(format) : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/formatDate.ts